// File created by Reginald Sahil Chand on 26-03-2024.

import React, {type ReactElement} from 'react';

export const Footer: React.FC = React.memo((): ReactElement => {
	return (
		<footer className="p-5 flex items-center justify-center text-center bg-footer md:col-span-2">
			<p className="text-base md:text-xl text-text">
				Copyright &copy; 2024&nbsp;
				<a
					href="https://github.com/Reginald-Sahil-Chand/Task-Quazar"
					target="_blank"
					rel="noreferrer noopener"
					title="Go to Task Quazar GitHub Account"
					aria-label="Go To Task Quazar GitHub Account"
					tabIndex={0}
					className="text-secondary hover:text-text transition-colors duration-300 ease-in-out"
				>
					Task Quazar,
				</a>
				<a
					href="https://github.com/Reginald-Sahil-Chand"
					target="_blank"
					rel="noreferrer noopener"
					title="Go to Reginald Sahil Chand's GitHub Account"
					aria-label="Go To Reginald Sahil Chand's GitHub Account"
					tabIndex={0}
					className="text-primary hover:text-text transition-colors duration-300 ease-in-out"
				>
					&nbsp;Reginald Sahil Chand
				</a>
			</p>
		</footer>
	);
});

Footer.displayName = 'Footer';
